import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70 mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-3">
              <span className="font-heading text-xl font-bold text-primary-500">91吃瓜网</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              最新热点吃瓜爆料聚合平台，专注收录娱乐圈、社会热点、明星八卦等吃瓜资讯，让你不错过任何精彩瓜料。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-3">分类导航</h4>
            <div className="space-y-2">
              {categories.slice(0, 3).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-3">更多分类</h4>
            <div className="space-y-2">
              {categories.slice(3).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-3">关于我们</h4>
            <div className="space-y-2">
              <Link to="/about" className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                品牌介绍
              </Link>
              <Link to="/about" className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                联系我们
              </Link>
              <a href="#" className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">
                用户协议
              </a>
              <a href="#" className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">
                隐私政策
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 91吃瓜网 - 最新热点吃瓜爆料聚合平台 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            本站内容仅供娱乐参考，不构成任何建议
          </p>
        </div>
      </div>
    </footer>
  );
}